import DeleteIcon from "@mui/icons-material/Delete";
import {bindPopover, bindTrigger, usePopupState} from "material-ui-popup-state/hooks";
import {
    Button,
    capitalize,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton
} from "@mui/material";
import {useUnteraufgabenHandling} from "../../hooks/unteraufgaben/useUnteraufgabenHandling";

interface ButtonDeleteUnteraufgabeProps {
    aufgabeId: string;
    unteraufgabeId: string;
}

export default function ButtonDeleteUnteraufgabe({aufgabeId, unteraufgabeId}: ButtonDeleteUnteraufgabeProps) {
    const {translation, deleteUnteraufgabeMutation} = useUnteraufgabenHandling();
    const popupState = usePopupState({
        variant: 'popover',
        popupId: `unteraufgabe-${unteraufgabeId}-delete`,
    });

    return (
        <>
            <IconButton id={`button-delete-unteraufgabe-${unteraufgabeId}`}
                        aria-label={`button-delete-unteraufgabe-${unteraufgabeId}`}
                        {...bindTrigger(popupState)}
            >
                <DeleteIcon/>
            </IconButton>
            <Dialog id={`dialog-delete-unteraufgabe-${unteraufgabeId}`}
                    {...bindPopover(popupState)}
            >
                <DialogTitle id={`dialog-title-delete-unteraufgabe-${unteraufgabeId}`}>
                    {capitalize(translation('delete-dialogue-title'))}
                </DialogTitle>
                <DialogContent id={`dialog-content-delete-unteraufgabe-${unteraufgabeId}`}>
                    <DialogContentText id={`dialog-content-text-delete-unteraufgabe-${unteraufgabeId}`}>
                        {capitalize(translation('delete-dialogue-description'))}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id={`dialog-action-cancel-delete-unteraufgabe-${unteraufgabeId}`}
                            color={'inherit'}
                            onClick={() => popupState.close()}
                    >
                        {capitalize(translation('abort'))}
                    </Button>
                    <Button id={`dialog-action-confirm-delete-unteraufgabe-${unteraufgabeId}`}
                            color={'error'}
                            variant={'contained'}
                            onClick={() => {
                                deleteUnteraufgabeMutation.mutate({
                                    aufgabeId: aufgabeId,
                                    unteraufgabeId: unteraufgabeId
                                });
                                popupState.close();
                            }}
                    >
                        {capitalize(translation('delete'))}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

